import { gql } from "@apollo/client";

const REGISTER = gql`
  mutation registerEntry($input: Credential!) {
    register(input: $input) {
      data
      status
      error
    }
  }
`;

export default REGISTER;
